import React, { useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { useMutation, useQuery, useNotify } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: { padding: 24, maxWidth: 620 },
  help: { marginTop: 8, marginBottom: 20, color: 'rgba(0, 0, 0, 0.6)' },
  // The floating label is absolutely positioned over the input, so if it wraps
  // it lands on top of the date value. Keep it on one line and give the field
  // room for it.
  dateField: { width: 260 },
  dateLabel: { whiteSpace: 'nowrap' },
  actions: { marginTop: 20 },
  spacer: { marginLeft: 12 },
})

export const MaintenancePanel = ({ id }) => {
  const classes = useStyles()
  const notify = useNotify()

  const { data: item } = useQuery({
    type: 'getOne',
    resource: 'modalities/settings',
    payload: { id },
  })

  const [date, setDate] = useState('')

  // What is actually stored, as opposed to what is currently typed in the box.
  const savedDate = (item && item.settings && item.settings.boiloffResetDate) || ''

  useEffect(() => {
    if (item) {
      setDate(savedDate)
    }
  }, [item, savedDate])

  const [mutate, { loading }] = useMutation()

  const save = (boiloffResetDate) =>
    mutate(
      {
        type: 'update',
        resource: 'modalities/settings',
        payload: { id, data: { boiloffResetDate } },
      },
      {
        onSuccess: () => {
          setDate(boiloffResetDate || '')
          notify(
            boiloffResetDate
              ? 'Boil-off measurement start date saved'
              : 'Boil-off measurement start date cleared'
          )
        },
        onFailure: (error) =>
          notify(`Could not save: ${error.message}`, 'warning'),
      }
    )

  return (
    <Box>
      <Paper className={classes.root}>
        <Typography variant='h6'>Helium boil-off</Typography>
        <Typography variant='body2' className={classes.help}>
          Boil-off metrics ignore helium readings recorded before this date. Set
          it after repairing a leak so the machine stops reporting losses from
          before the repair. Metrics show as recalibrating for about ten days
          afterwards, until enough new data has been collected.
        </Typography>

        <TextField
          label='Measurement start date'
          type='date'
          className={classes.dateField}
          value={date}
          onChange={(e) => setDate(e.target.value)}
          InputLabelProps={{ shrink: true, className: classes.dateLabel }}
          disabled={loading}
        />

        <Box className={classes.actions}>
          <Button
            variant='contained'
            color='primary'
            disabled={loading || !date}
            onClick={() => save(date)}
          >
            Save
          </Button>
          <Button
            className={classes.spacer}
            disabled={loading || !savedDate}
            onClick={() => save(null)}
          >
            Clear
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
